export const frontend_Skills = [
  {
    name: "Javascript",
    percent: "80",
  },
  {
    name: "Typescript",
    percent: "70",
  },
  {
    name: "React Js",
    percent: "80",
  },
  {
    name: "Next Js",
    percent: "80",
  },
  {
    name: "Bootstrap",
    percent: "80",
  },
  {
    name: "Materila UI",
    percent: "80",
  },
  {
    name: "Tailwind CSS",
    percent: "80",
  },
  {
    name: "SCSS",
    percent: "80",
  },
];

export const backend_Skills = [
  {
    name: "Node Js",
    percent: "70",
  },
  {
    name: "Express Js",
    percent: "80",
  },
  {
    name: "Mongoose",
    percent: "80",
  },
  {
    name: "Prisma",
    percent: "80",
  },
  {
    name: "Python",
    percent: "60",
  },
  {
    name: "django",
    percent: "50",
  },
  {
    name: "MongoDB",
    percent: "70",
  },
  {
    name: "MySql",
    percent: "60",
  },
];
